'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { ArrowArrowRight } from '@s7/icons';
import { packSX } from '@s7/styles';
import { TextButton } from '@s7/ui';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ShowMore = function(props) {
    var title = props.title, link = props.link, sx = props.sx, others = _object_without_properties_loose(props, [
        "title",
        "link",
        "sx"
    ]);
    var unpackLink = useLinkOverride();
    return /*#__PURE__*/ jsx(TextButton, _extends({
        rightSide: /*#__PURE__*/ jsx(ArrowArrowRight, {
            color: "text.tertiary",
            size: 12,
            sx: {
                display: "flex"
            }
        }),
        sx: [].concat([
            function(theme) {
                return _extends({}, theme.fn.focusRing({
                    selector: "&[data-hovered=true]",
                    color: theme.palette.primary.mid
                }));
            }
        ], packSX(sx)),
        as: "a",
        color: "text.tertiary"
    }, unpackLink(link), others, {
        children: title
    }));
};

export { ShowMore };
